import React from "react";
import { FiLoader } from "react-icons/fi";

export default function Spinner({ className = "h-5 w-5", label = "Loading" }) {
  return (
    <div role="status" aria-label={label} className="flex items-center justify-center">
      <FiLoader className={`animate-spin text-primary-500 ${className}`} />
    </div>
  );
}
